import { render, staticRenderFns } from "./ProductionViewConfiguratorStep2.vue?vue&type=template&id=c622cfec"
import script from "./ProductionViewConfiguratorStep2.vue?vue&type=script&lang=js"
export * from "./ProductionViewConfiguratorStep2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports